define('entities/admin/snippets',[
  'app',
  'jquery',
  'underscore',
  'backbone',
  'settings',
  'backboneRelational'
], function (
  App,
  $,
  _,
  Backbone,
  Settings
) {
  'use strict';

  var app;
  if (Backbone.Relational.store._modelScopes && Backbone.Relational.store._modelScopes.length > 0) {
    app = { ns: Backbone.Relational.store._modelScopes[0] };
  } else {
    app = { ns: {} };
    Backbone.Relational.store.addModelScope(app.ns);
  }

  app.ns.Snippet = Backbone.RelationalModel.extend({
    defaults: {
      secId: null,
      shortcut: '',
      body: '',
      bodyByLocale: {},
      enabled: true,
      caseSensitive: false,
      description: ''
    },
    idAttribute: 'secId'
  });

  App.reqres.setHandler('snippets:model', function (json) {
    var existing = null;
    if (json && json.secId) {
      existing = Backbone.Relational.store.find(app.ns.Snippet, json.secId);
    }
    if (existing) {
      existing.set(json);
      return existing;
    }
    return new app.ns.Snippet(json);
  });

  var API = {
    getListUrl: function (params) {
      return Settings.url('compuzz2', 'v2/snippets', params);
    },
    getRowCountUrl: function (params) {
      return Settings.url('compuzz2', 'v2/snippets/rowCount', params);
    },
    getOneUrl: function (secId) {
      return Settings.url('compuzz2', 'v2/snippets/' + secId);
    },
    getCollectionUrl: function () {
      return Settings.url('compuzz2', 'v2/snippets');
    },
    getDeleteUrl: function (secId) {
      return Settings.url('compuzz2', 'v2/snippets/' + secId);
    }
  };

  App.reqres.setHandler('snippets:get-url', function (params) {
    return API.getListUrl(params);
  });

  App.reqres.setHandler('snippets:row-count-url', function (params) {
    return API.getRowCountUrl(params);
  });

  App.reqres.setHandler('snippets:get', function (secId) {
    var defer = $.Deferred();
    $.ajax({
      type: 'GET',
      url: API.getOneUrl(secId),
      success: function (data) { defer.resolve(data); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });

  App.reqres.setHandler('snippets:create', function (json) {
    var defer = $.Deferred();
    $.ajax({
      type: 'POST',
      url: API.getCollectionUrl(),
      contentType: 'application/json',
      data: JSON.stringify(json),
      success: function (data) { defer.resolve(data); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });

  App.reqres.setHandler('snippets:update', function (json) {
    var defer = $.Deferred();
    $.ajax({
      type: 'PUT',
      url: API.getCollectionUrl(),
      contentType: 'application/json',
      data: JSON.stringify(json),
      success: function (data) { defer.resolve(data); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });

  App.reqres.setHandler('snippets:delete', function (secId) {
    var defer = $.Deferred();
    $.ajax({
      type: 'DELETE',
      url: API.getDeleteUrl(secId),
      success: function () { defer.resolve(); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });
});

